import axios from '../../lib/axios';
import { IUser } from '../../models/account/accountModel';

export const getConfigUsersById = async (configUserKey): Promise<any> => {
    const response = await axios.get<IUser>(
        `/ConfigAccount/GetConfigUserByUserKey?configUserKey=${configUserKey}`
    );
    return response?.data;
};

export const updateConfigUser = async (userData: any): Promise<any> => {
    const response = await axios.post<any>(
        'ConfigUser/UpdateConfigUser', userData
    );
    return response?.data;
};